import React from "react";
import cx from "classnames";

import styles from "./metrics.module.scss";

export type LearningsMetricsValueVariant = "primary" | "warning";

interface MetricsProps {
  name: string;
  value: string;
  subTitle?: string;
  valueVariant?: LearningsMetricsValueVariant;
}

export const Metrics: React.FC<MetricsProps> = ({
  name,
  value,
  subTitle,
  valueVariant = "primary",
}) => {
  return (
    <div className={styles.infoCard}>
      <div className={styles.metrics}>
        <span className={styles.name}>{name}</span>
        <span
          className={cx(styles.value, {
            [styles.valueWarning]: valueVariant === "warning",
          })}
        >
          {value}
        </span>
        {subTitle && <span className={styles.subTitle}>{subTitle}</span>}
      </div>
    </div>
  );
};
